'use strict';

var _ = require('lodash');
var DashboardPanelTransformerFactory = function DashboardPanelTransformerFactory(DataTransformer) {
  function DashboardPanelTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'market-dashboard';
    this.priority = 0;
  }
  var metricNameTypeMapping = {
    bookings: 'Bookings',
    revenue: 'Revenue',
    group_bookings: 'GroupBookings',
    loadFactor: 'LoadFactor'
  };
  DashboardPanelTransformer.prototype = Object.create(DataTransformer.prototype);
  DashboardPanelTransformer.constructor = DashboardPanelTransformer;
  DashboardPanelTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  DashboardPanelTransformer.prototype.isCacheable = function () {
    return true;
  };
  DashboardPanelTransformer.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + metrics.join('-');
  };
  function nestedDataRetriever(object, path) {
    var length = path.length;
    var result = object;
    for (var i = 0; i < length; i++) {
      result = result[path[i]];
      if (result === undefined) {
        return 0;
      }
    }
    return result;
  }
  function emptyMetrics() {
    return {
      currentMetrics: {},
      finalMetrics: {}
    };
  }
  function getLastYearReferenceMetrics(currentPos) {
    return _.get(currentPos, ['metrics', 'referenceData'], emptyMetrics());
  }
  function getSeasonalAvgReferenceMetrics(currentPos) {
    return _.get(currentPos, ['metrics', 'seasonalAverageData'], emptyMetrics());
  }
  DashboardPanelTransformer.prototype.transform = function (data, metrics, metricDescriptor) {
    var transformed = [];
    var metricName = metricDescriptor.metric;
    var type = metricNameTypeMapping[metricName];
    if (data.domain._embedded && data.domain._embedded.marketMonthMetrics) {
      var target = data.secondDomain.target;
      data = data.domain._embedded.marketMonthMetrics;
      var metricsKeys = [];
      var splitMetricsKeys = [];
      var mlength = metrics.length;
      var dimension = metricDescriptor.dimension.toLocaleUpperCase();
      for (var m = 0; m < mlength; m++) {
        metricsKeys[m] = 'm' + (m + 1);
        splitMetricsKeys.push(metrics[m].split('.'));
      }
      for (var index = 0, dataLength = data.length; index < dataLength; index++) {
        var currentElement = data[index];
        var isLocalMarket = !_.isEmpty(currentElement.cabins);

        //we have to dimensions : REGULAR and MAPPED
        if (dimension !== currentElement.flowType) {
          continue;
        }
        if (metricName === 'loadFactor' && _.isArray(currentElement.cabins)) {
          for (var cabinIndex = 0, cabinLength = currentElement.cabins.length; cabinIndex < cabinLength; cabinIndex++) {
            var currentCabin = currentElement.cabins[cabinIndex];
            var targetEntryForCabin = _.find(target, {
              month: currentElement.month,
              targetType: type,
              marketDestination: currentElement.destination,
              marketOrigin: currentElement.origin,
              year: currentElement.year
            }) || {};
            var cabinElement = {
              carrier: currentElement.carrier,
              market: currentElement.origin + '-' + currentElement.destination,
              month: currentElement.month - 1,
              year: currentElement.year,
              isLocal: isLocalMarket,
              cabin: currentCabin.cabinCode,
              pos: undefined,
              posAlerts: undefined,
              cabinAlerts: currentElement.alerts,
              budget: targetEntryForCabin.budgetValue || 0,
              target: targetEntryForCabin.targetValue || 0
            };
            for (m = 0; m < mlength; m++) {
              cabinElement[metricsKeys[m]] = nestedDataRetriever(currentCabin, splitMetricsKeys[m]);
            }
            cabinElement[metricsKeys[2]] = {
              LY: _.get(currentCabin, ['referenceData', 'lastYearCurrentLoadFactorAverageItem']) || 0,
              SEASONAL_AVG: _.get(currentCabin, ['seasonalAverageData', 'currentLoadFactorAverageItem']) || 0
            };
            cabinElement[metricsKeys[3]] = {
              LY: _.get(currentCabin, ['referenceData', 'lastYearFinalLoadFactorAverageItem']) || 0,
              SEASONAL_AVG: _.get(currentCabin, ['seasonalAverageData', 'finalLoadFactorAverageItem']) || 0
            };
            transformed.push(cabinElement);
          }
        } else {
          for (var posIndex = 0, posLength = currentElement.pointOfSales.length; posIndex < posLength; posIndex++) {
            var currentPos = currentElement.pointOfSales[posIndex];
            var targetEntryForPOS = _.find(target, {
              month: currentElement.month,
              targetType: type,
              marketDestination: currentElement.destination,
              marketOrigin: currentElement.origin,
              spos: currentPos.posName,
              year: currentElement.year
            }) || {};
            var posElement = {
              carrier: currentElement.carrier,
              market: currentElement.origin + '-' + currentElement.destination,
              month: currentElement.month - 1,
              year: currentElement.year,
              isLocal: isLocalMarket,
              pos: currentPos.posName,
              posAlerts: currentPos.alerts,
              cabinAlerts: currentElement.alerts,
              budget: targetEntryForPOS.budgetValue || 0,
              target: targetEntryForPOS.targetValue || 0
            };
            for (m = 0; m < mlength; m++) {
              posElement[metricsKeys[m]] = 0;
            }
            for (var classIndex = 0, classesLength = currentPos.classes.length; classIndex < classesLength; classIndex++) {
              var currentClass = currentPos.classes[classIndex];
              for (m = 0; m < mlength; m++) {
                posElement[metricsKeys[m]] += nestedDataRetriever(currentClass, splitMetricsKeys[m]);
              }
            }

            // reference data is taken directly from a POS-aggregated object
            var lyReferenceData = getLastYearReferenceMetrics(currentPos);
            var seasonalAvgReferenceData = getSeasonalAvgReferenceMetrics(currentPos);
            var lyPropertyName = metricName === 'bookings' ? 'resHoldTotal' : 'revenue';
            var saPropertyName = metricName === 'bookings' ? 'bookings' : 'revenue';
            posElement[metricsKeys[2]] = {
              LY: _.get(lyReferenceData, ['currentMetrics', lyPropertyName]) || 0,
              SEASONAL_AVG: _.get(seasonalAvgReferenceData, ['currentMetrics', saPropertyName]) || 0
            };
            posElement[metricsKeys[3]] = {
              LY: _.get(lyReferenceData, ['finalMetrics', lyPropertyName]) || 0,
              SEASONAL_AVG: _.get(seasonalAvgReferenceData, ['finalMetrics', saPropertyName]) || 0
            };
            transformed.push(posElement);
          }
        }
      }
    }
    return transformed;
  };
  return DashboardPanelTransformer;
};
DashboardPanelTransformerFactory.$inject = ['DataTransformerFactory'];
module.exports = DashboardPanelTransformerFactory;